import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { formatAmountCurrency } from '../../../../../utils/index';

class CashbackByStatusComponent extends React.Component {
    render() {
        const { cssClass, amount, txt } = this.props;

        return (
            <div className={`${cssClass} bloc align`}>
                <div className={`${cssClass} header`}>{txt}</div>
                <div className={`${cssClass} footer`}>{formatAmountCurrency(amount)}</div>
            </div>
        );
    }
}

CashbackByStatusComponent.propTypes = {
    cssClass: PropTypes.string.isRequired,
    txt: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT
    };
}

export default connect(mapStateToProps)(CashbackByStatusComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/resume/CashbackByStatusComponent.js